import {
    HomeOutlined,
    MonetizationOn,
    VerifiedUser,
    NoteAlt,
    ShoppingCart,
    QueryStats,
    // Receipt,
} from "@mui/icons-material";


const NavItems = () => {
    const navItems = [
        {
            text: "Dashboard",
            icon: <HomeOutlined />,
            path: "dashboard",
            group: "dashboard",
            roles: [], 
        },
        {
            text: "Sales",
            icon: null,
            path: null,
            group: "Sales",
            roles: [],
        },    
        // {
        //     text: "Invoices",
        //     icon: <Receipt />,
        //     path: "invoices",
        //     group: "Sales",
        //     roles: [],
        // },              
        {
            text: "Crew Sales",
            icon: <MonetizationOn />,
            path: "crewsales",
            group: "Sales",
            roles: [],
        },
        // {
        //     text: "Inflight Sales",
        //     icon: <ShoppingCart />,
        //     path: "inflight",
        //     group: "Sales",
        //     roles: [],
        // },
        // {
        //     text: "Sales Stats",
        //     icon: <QueryStats />,
        //     path: "inflight-stats",
        //     group: "Sales",
        //     roles: [],
        // },
        // {
        //     text: "Schedule",
        //     icon: null,
        //     path: null,
        //     group: "crewschedule",
        //     roles: [],
        // },                 
        // {
        //     text: "Crew Rosters",
        //     icon: <CalendarMonth />,
        //     path: "rosterdetails",
        //     group: "crewschedule",
        //     roles: [],
        // },
        {
            text: "Requests",
            icon: null,
            path: null,
            group: "Requests",
            roles: [],
        },
        {
            text: "Crew Requests",
            icon: <NoteAlt />,
            path: "crewrequests",
            group: "Requests",
            roles: [],
        },
        {
            text: "Auth",
            icon: null,
            path: null,
            group: "auth",
            roles: [],
        },
        {
            text: "Change Password",
            icon: <VerifiedUser />,
            path: "changepassword",
            group: "auth",
            roles: [],
        },
    ];
    
    return navItems;
};

export default NavItems;
